/**
 * 复制一段文字到剪贴板。返回是否成功。
 *
 * http 页面或者旧浏览器里没有 `navigator.clipboard`。**不能就这么算了** ——
 * 分享链接、玩家 ID 复制不了的话，玩家只能手抄，退回到隐藏 textarea + execCommand。
 *
 * **`writeText` 带一个超时，是兜底。** 规范没保证它一定会很快落地（比如卡在权限询问上）——
 * 真那样的话调用方永远等不到结果，界面上点了毫无反应，连"复制失败"都说不出来。
 */
const CLIPBOARD_TIMEOUT_MS = 1500;

export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await Promise.race([
        navigator.clipboard.writeText(text),
        new Promise((_, reject) => setTimeout(
          () => reject(new Error('clipboard timeout')), CLIPBOARD_TIMEOUT_MS)),
      ]);
      return true;
    }
  } catch {
    /* 退回老办法 */
  }
  try {
    const el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    try {
      return document.execCommand('copy');
    } finally {
      el.remove();
    }
  } catch {
    return false;
  }
}
